<section class="main-content wrapper content-padding">
  <div class="content-panel">
    <div class="tabs">
      <label class="tab">
        <a
          class="tab-link active-tab"
        >
          FINANZA <!--FINANCE-->
        </a>
      </label>
    </div>
    <div class="tabs">
      <label class="tab">
        <a
          class="tab-link"
          routerLink="/finanza/corrispettivi"
          routerLinkActive="active-tab"
        >
          CORRISPETTIVI <!--FEES-->
        </a>
      </label>
  
      <label class="tab">
        <a
          class="tab-link"
          routerLink="/finanza/margini"
          routerLinkActive="active-tab"
        >
          MARGINI <!--MARGINS-->
        </a>
      </label>
    </div>
    <router-outlet></router-outlet>
  </div>
</section>
